import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Sube al inicio de la página cada vez que cambia la URL
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}